<ng-container *ngIf="job">
<div class="job-wrapper">
  <div style="width: 100%;gap: 1rem;flex-direction: column; display:flex;">
    <div class="job-header">
      <h2 class="job-title">{{ job.title }}</h2>
    </div>

    <div class="job-tags">
      <span class="tag"><img src="../../../../../assets/icons/flags/4x3/de.svg" alt="German flag" class="flag"/>
        {{ job.location }}</span>
      <span class="tag">{{'job_details.sidebar.salary' | translate}}: {{ job.salaryRange }}</span>
      <span class="tag">{{'job_details.sidebar.experience' | translate}}: {{ job.experience }}</span>
    </div>

    <div class="job-actions" (click)="$event.stopPropagation()">
      <app-button
        [label]="'job_details.buttons.edit' | translate"
        (click)="editJobOffer()"
        [showLeftIcon]="true"
        [leftIcon]="'assets/icons/edit-light.svg'"
        [size]="ButtonSize.LARGE"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.SECONDARY"
      ></app-button>

      <app-button
        [showLeftIcon]="true"
        (click)="deleteJobOffer()"
        [borderColor]="'#FF6262'"
        [leftIcon]="'assets/icons/delete.png'"
        [label]="'job_details.buttons.delete' | translate"
        [size]="ButtonSize.LARGE"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.SECONDARY"
      ></app-button>
    </div>
  </div>
  <div class="job-applications" (click)="$event.stopPropagation()">
    <div>
      <div class="application-count">{{applications?.length}}</div>
      <span class="go-link">↗</span>
    </div>
    <div class="label">{{ 'dashboard.recentApplications' | translate}}</div>
    <div class="avatars">
      <img *ngFor="let applicant of applications | slice:0:5"
           [src]="applicant.applicantProfileImageUrl"
           [alt]="applicant.applicantName"
           class="avatar-image" />
    </div>

  </div>
</div>
</ng-container>
